import React, { useState } from "react";
import classNames from "classnames";
import styles from "./SignShop.module.scss";

type Props = {
    phone?: string;
    display: boolean;
    change: (string) => void;
    close: () => void;
}

const NoNumberWelcome: React.FC<Props> = (props: Props) => {
    const [phone, setPhone] = useState(props.phone);

    const letsGoClasses = classNames("btn", "lets-go", {
        [styles.hide]: false,
        [styles.show]: true,
    });

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
        setPhone(e.currentTarget.value);
    };

    const go = (e: React.FormEvent<HTMLInputElement>) => {
        e.preventDefault();
        props.change(phone);
        props.close();
    };

    let style = {
        opacity: 0,
        display: "none",
    };
    if (props.display) {
        style = {
            opacity: 1,
            display: "flex",
        }
    }


    return (
        <div className="no-number-welcome" style={style}>
            <div className="no-num-box">
                <h2>Please Enter Your Wedding Hashtag</h2>
                <form id="enterGiveNumForm" className="enter-change-num">
                    <input type="tel" id="enterGiveNum" placeholder="#MyWeddingHashtag" onChange={onChange} />
                    <input type="submit" value="OK! Let's Go!" id="okLetsGo" className={letsGoClasses} onClick={go}/>
                </form>
                <div className="just-browsing" onClick={props.close}>I'm just browsing</div>
            </div>
        </div>
    );
};

export default NoNumberWelcome;
